import { Col, DatePicker, Row } from 'antd';
import moment from 'moment';

import { StockCorrectionsQuery } from '@/core/domain/stock/StockCorrections/StockCorrections.types';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';

function StockCorrectionsExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<StockCorrectionsQuery>) {
  return (
    <Row gutter={[16, 16]}>
      <Col span={24} md={12} lg={6}>
        <DatePicker
          format="DD/MM/YYYY"
          style={{ width: '100%' }}
          value={queryParams?.date ? moment(queryParams?.date) : undefined}
          onChange={(value) =>
            setQueryParams((prev) => ({ ...prev, date: value?.toISOString() }))
          }
        />
      </Col>
      <Col span={24} md={12} lg={6}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default StockCorrectionsExtraFilters;
